<template>
    <div class="vue-view-toggle">
        <div v-for="view in viewModes" :class="{'active': viewMode === view.slug}" class="view-toggle-item">
            <button @click="handleClick(view.slug)" :class="{'grid-view': view.slug === 'grid'}">{{ view.title }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewToggle",

    props: ['viewMode'],

    data() {
        return {
            viewModes: [
                {
                    title: 'Slider',
                    slug: 'slider',
                },
                {
                    title: 'Grid',
                    slug: 'grid',
                }
            ]
        }
    },

    methods: {
        handleClick(payload) {
            this.$emit('view-mode-changed', payload);
        }
    }
}
</script>

<style scoped lang="scss">
ul {
    list-style: none;
    padding: 0;
}

.active {
    button {
        color: red
    }
}
</style>